module.exports = __webpack_public_path__ + "static/media/pic11-min.5e79506a.jpg";